import { render, staticRenderFns } from "./SecSafety_SKST.vue?vue&type=template&id=fb1cbeea&scoped=true&"
import script from "./SecSafety_SKST.vue?vue&type=script&lang=js&"
export * from "./SecSafety_SKST.vue?vue&type=script&lang=js&"
import style0 from "./SecSafety_SKST.vue?vue&type=style&index=0&id=fb1cbeea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1cbeea",
  null
  
)

export default component.exports